import React, { useState, useEffect, useRef } from "react";
import { HiX } from "react-icons/hi";
import { GrDownload } from "react-icons/gr";
// import NewFooter from "./NewFooter";
import NewFooter from "../Footer/NewFooter";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useLocation } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const Confirmation = () => {
  const [open, setOpen] = useState(false);
  const [animateClose, setAnimateClose] = useState(false);
  const [isBlocked] = useState(false);

  const sectionsRef = useRef([]);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const booking = {
    status: params.get("status"),
    villaId: params.get("villaId"),
    name: params.get("name"),
    email: params.get("email"),
    phone: params.get("phone"),
    checkIn: params.get("checkIn"),
    checkOut: params.get("checkOut"),
    specialRequests: params.get("specialRequests"),
    villaName: params.get("villaName"),
    nights: params.get("nights"),
    price: params.get("price"),
    taxes: params.get("taxes"),
    total: params.get("total"),
    adults: params.get("adults"),
    children: params.get("children"),
    transactionId: params.get("transactionid"),
  };
  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    sectionsRef.current.forEach((section) => {
      const texts = section.querySelectorAll("p, h2");
      if (texts.length === 0) return;

      gsap.fromTo(
        texts,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }, []);

  const handleClose = () => {
    setAnimateClose(true);
    setTimeout(() => {
      setOpen(false);
      setAnimateClose(false);
    }, 550);
  };

  return (
    <>
      <header
        className={`
            h-20 flex items-center w-full transition-all duration-300
            sticky top-0 z-[100]
            ${open ? "bg-[#f5f2f0]" : "bg-transparent"}
        `}
      >
        <div className="flex justify-between items-center w-full px-10 lg:px-20">
          <a href="/HomePage">
            <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
          </a>

          <div className="hidden lg:block ml-auto absolute right-40 top-7">
            <a href="/BookNow" onClick={handleClose}>
              <div
                className="text-[15px] text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp underline underline-offset-4"
                style={{ animationDelay: "0.45s" }}
              >
                Reserve Now!
              </div>
            </a>
          </div>

          {!open ? (
            <button
              onClick={() => !isBlocked && setOpen(true)}
              className="flex flex-col space-y-2.5 absolute right-10 lg:right-20 top-6 opacity-100 pointer-events-auto"
            >
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
            </button>
          ) : (
            <button
              onClick={handleClose}
              className="text-3xl text-[#948A78] absolute right-8 sm:right-10 lg:right-20 top-6 z-[70]"
            >
              <HiX />
            </button>
          )}
        </div>

        {(open || animateClose) && (
          <>
            <div
              onClick={handleClose}
              className={`fixed left-0 top-20 h-[calc(100vh-80px)] w-full
                transition-opacity duration-500 z-[49]
                ${
                  animateClose
                    ? "opacity-0 pointer-events-none"
                    : "opacity-100 pointer-events-auto"
                }`}
            ></div>

            <div
              className={`fixed top-20 right-0 h-[calc(100vh-80px)]
                bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent
                w-full px-10 py-16 flex flex-col justify-between text-left
                overflow-hidden z-[50]
                ${
                  animateClose
                    ? "animate-menuSlideLeftToRight"
                    : "animate-menuSlideRightToLeft"
                }`}
            >
              <div className="flex justify-end w-full">
                <nav className="flex flex-col text-left text-xl tracking-[0.3em] text-[#948A78] space-y-8 sm:mr-5 lg:mt-5 -mt-8">
                  {["Our Philosophy", "Our Spaces", "Our Services"].map(
                    (item, index) => (
                      <a
                        key={index}
                        href={`/${item.replace(/\s/g, "")}`}
                        onClick={handleClose}
                        className="transform translate-y-20 opacity-0 animate-slideUp"
                        style={{ animationDelay: `${index * 0.25}s` }}
                      >
                        {item}
                      </a>
                    )
                  )}

                  <div
                    className="flex items-center space-x-2 transform translate-y-20 opacity-0 animate-slideUp cursor-pointer"
                    style={{ animationDelay: "0.8s" }}
                  >
                    <a
                      href="../assets/House_of_Tao.pdf"
                      target="_blank"
                      onClick={handleClose}
                      className="text-[#948A78] text-xl tracking-[0.3em] flex items-center xl:mt-60 lg:mt-44 lg:ml-3"
                    >
                      <GrDownload className="mr-3" /> Brochure
                    </a>
                  </div>
                </nav>
              </div>

              <div className="flex justify-center mb-10 lg:hidden">
                <a
                  href="/BookNow"
                  onClick={handleClose}
                  className="text-xl text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp sm:ml-[70vh] ml-7 underline underline-offset-4"
                  style={{ animationDelay: "0.85s" }}
                >
                  Reserve Now!
                </a>
              </div>
            </div>
          </>
        )}

        <style jsx>{`
          @keyframes slideUp {
            0% {
              opacity: 0;
              transform: translateY(50px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-slideUp {
            animation: slideUp 0.85s forwards;
          }
          @keyframes menuSlideRightToLeft {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0);
            }
          }
          .animate-menuSlideRightToLeft {
            animation: menuSlideRightToLeft 0.55s ease forwards;
          }
          @keyframes menuSlideLeftToRight {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(100%);
            }
          }
          .animate-menuSlideLeftToRight {
            animation: menuSlideLeftToRight 0.55s ease forwards;
          }
        `}</style>
      </header>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-20 lg:mt-8">
        <div ref={addToRefs} className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="hidden lg:block space-y-6 xl:px-24 lg:px-5 max-w-xl">
            <div className="flex justify-between w-[480px] items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Dates
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                {booking.checkIn} – {booking.checkOut}
              </p>
            </div>

            <div className="flex justify-between w-[490px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Guests
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                {booking.adults} Adults
                {booking.children > 0 ? `, ${booking.children} Children` : ""}
              </p>
            </div>

            <div className="flex justify-between w-[480px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Name
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                {booking.name}
              </p>
            </div>

            <div className="flex justify-between w-[480px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Email
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                {booking.email}
              </p>
            </div>

            <div className="flex justify-between w-[480px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Mobile
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                {booking.phone}
              </p>
            </div>

            <div className="flex justify-between w-[600px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 xl:-ml-10 lg:-ml-28">
                Nights
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-14 lg:mr-36">
                ({booking.nights} Night{booking.nights > 1 ? "s" : ""})
              </p>
            </div>

            <div className="flex justify-between w-[600px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 xl:-ml-10 lg:-ml-28">
                Special&nbsp;Request
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-12 lg:mr-36">
                {booking.specialRequests}
              </p>
            </div>

            <div className="flex justify-between w-[490px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-20 xl:-ml-0">
                Taxes
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-20">
                Rs {booking.taxes}
              </p>
            </div>

            <div className="flex justify-between xl:w-[480px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-10 xl:-ml-0">
                Price
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-10">
                Rs {booking.price}
              </p>
            </div>

            <div className="flex justify-between xl:w-[490px]  items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-10 lg:-ml-10 xl:-ml-0">
                Total&nbsp;Cost
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] text-left w-3/5 xl:mr-0 lg:mr-10">
                Rs {booking.total}
              </p>
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-end">
            <img
              src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public"
              alt="Trip Confirmation"
              className="w-[70vh] h-[50vh] xl:w-[80vh] xl:h-[60vh] 2xl:h-[45vh] object-cover"
            />

            <div className="bg-[#f5f2f0] py-10 px-10 mt-14 w-[70vh] xl:w-[80vh] 2xl:w-[70vh]">
              <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[13px] mb-6 -ml-10">
                Trip Confirmed
              </p>

              <p className="text-[#948A78] text-[20px] leading-relaxed ml-28">
                Congratulations, your trip with us is
                <br />
                booked with us!
              </p>

              <p className="text-[#948A78] text-[20px] mt-4  ml-28">
                We look forward to hosting you!
              </p>
            </div>
          </div>
        </div>

        {/* mobile */}
        <div ref={addToRefs} className="lg:hidden mt-10">
          <div className="w-full flex justify-center mt-10">
            <div className="bg-[#f5f2f0] py-10 px-8 w-full max-w-[450px]">
              <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[12px] mb-4">
                Trip Confirmed
              </p>

              <p className="text-[#948A78] text-[18px] leading-relaxed">
                Congratulations, your trip with us is booked!
              </p>

              <p className="text-[#948A78] text-[18px] mt-4">
                We look forward to hosting you!
              </p>
            </div>
          </div>

          <div className="lg:hidden space-y-6 w-full max-w-[520px] mx-auto">
            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Dates
              </p>
              <p className="text-[#948A78] hidden sm:block tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.checkIn} – {booking.checkOut}
              </p>
              <p className="text-[#948A78] sm:hidden block tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.checkIn} – {booking.checkOut}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Guests
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.adults} Adults
                {booking.children > 0 ? `, ${booking.children} Children` : ""}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Name
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.name}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Email
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.email}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Mobile
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.phone}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[17px] text-right w-2/5 pr-6">
                Nights
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                ({booking.nights} Night{booking.nights > 1 ? "s" : ""})
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Special Request
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                {booking.specialRequests}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Taxes
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                Rs {booking.taxes}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Price
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                Rs {booking.price}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <p className="text-[#948A78] text-[18px] text-right w-2/5 pr-6">
                Total Cost
              </p>
              <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] w-3/5">
                Rs {booking.total}
              </p>
            </div>
          </div>

          <div className="-mx-6 lg:hidden mt-10">
            <img
              src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public"
              alt="Trip"
              className="w-screen h-[40vh] sm:h-[65vh] object-cover"
            />
          </div>
        </div>
      </div>

      <NewFooter />
    </>
  );
};

export default Confirmation;

// import React, { useState, useEffect, useRef } from "react";
// import { HiX } from "react-icons/hi";
// import { GrDownload } from "react-icons/gr";
// import NewFooter from "../Footer/NewFooter";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// const Confirmation = () => {
//   const [open, setOpen] = useState(false);
//   const [animateClose, setAnimateClose] = useState(false);
//   const [isBlocked] = useState(false);

//   const sectionsRef = useRef([]);

//   const addToRefs = (el) => {
//     if (el && !sectionsRef.current.includes(el)) {
//       sectionsRef.current.push(el);
//     }
//   };

//   useEffect(() => {
//     sectionsRef.current.forEach((section) => {
//       const texts = section.querySelectorAll("p, h2");
//       if (texts.length === 0) return;

//       gsap.fromTo(
//         texts,
//         { opacity: 0, y: 60 },
//         {
//           opacity: 1,
//           y: 0,
//           duration: 1,
//           stagger: 0.3,
//           ease: "power2.out",
//           scrollTrigger: {
//             trigger: section,
//             start: "top 90%",
//             toggleActions: "play none none none",
//           },
//         }
//       );
//     });
//   }, []);

//   const handleClose = () => {
//     setAnimateClose(true);
//     setTimeout(() => {
//       setOpen(false);
//       setAnimateClose(false);
//     }, 550);
//   };

//   return (
//     <>
//       <header
//         className={`
//             h-20 flex items-center w-full transition-all duration-300
//             sticky top-0 z-[100]
//             ${open ? "bg-[#f5f2f0]" : "bg-transparent"}
//         `}
//       >
//         <div className="flex justify-between items-center w-full px-10 lg:px-20">
//           <a href="/HomePage">
//             <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
//           </a>

//           <div className="hidden lg:block ml-auto absolute right-40 top-7">
//             <a href="/BookNow" onClick={handleClose}>
//               <div
//                 className="text-[15px] text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp underline underline-offset-4"
//                 style={{ animationDelay: "0.45s" }}
//               >
//                 Reserve Now!
//               </div>
//             </a>
//           </div>

//           {!open ? (
//             <button
//               onClick={() => !isBlocked && setOpen(true)}
//               className="flex flex-col space-y-2.5 absolute right-10 lg:right-20 top-6 opacity-100 pointer-events-auto"
//             >
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//             </button>
//           ) : (
//             <button
//               onClick={handleClose}
//               className="text-3xl text-[#948A78] absolute right-8 sm:right-10 lg:right-20 top-6 z-[70]"
//             >
//               <HiX />
//             </button>
//           )}
//         </div>

//         {(open || animateClose) && (
//           <>
//             <div
//               onClick={handleClose}
//               className={`fixed left-0 top-20 h-[calc(100vh-80px)] w-full
//                 transition-opacity duration-500 z-[49]
//                 ${
//                   animateClose
//                     ? "opacity-0 pointer-events-none"
//                     : "opacity-100 pointer-events-auto"
//                 }`}
//             ></div>

//             <div
//               className={`fixed top-20 right-0 h-[calc(100vh-80px)]
//                 bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent
//                 w-full px-10 py-16 flex flex-col justify-between text-left
//                 overflow-hidden z-[50]
//                 ${
//                   animateClose
//                     ? "animate-menuSlideLeftToRight"
//                     : "animate-menuSlideRightToLeft"
//                 }`}
//             >
//               <div className="flex justify-end w-full">
//                 <nav className="flex flex-col text-left text-xl tracking-[0.3em] text-[#948A78] space-y-8 sm:mr-5 lg:mt-5 -mt-8">
//                   {["Our Philosophy", "Our Spaces", "Our Services"].map(
//                     (item, index) => (
//                       <a
//                         key={index}
//                         href={`/${item.replace(/\s/g, "")}`}
//                         onClick={handleClose}
//                         className="transform translate-y-20 opacity-0 animate-slideUp"
//                         style={{ animationDelay: `${index * 0.25}s` }}
//                       >
//                         {item}
//                       </a>
//                     )
//                   )}

//                   <div
//                     className="flex items-center space-x-2 transform translate-y-20 opacity-0 animate-slideUp cursor-pointer"
//                     style={{ animationDelay: "0.8s" }}
//                   >
//                     <a
//                       href="../assets/House_of_Tao.pdf"
//                       target="_blank"
//                       onClick={handleClose}
//                       className="text-[#948A78] text-xl tracking-[0.3em] flex items-center xl:mt-60 lg:mt-44 lg:ml-3"
//                     >
//                       <GrDownload className="mr-3" /> Brochure
//                     </a>
//                   </div>
//                 </nav>
//               </div>

//               <div className="flex justify-center mb-10 lg:hidden">
//                 <a
//                   href="/BookNow"
//                   onClick={handleClose}
//                   className="text-xl text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp sm:ml-[70vh] ml-7 underline underline-offset-4"
//                   style={{ animationDelay: "0.85s" }}
//                 >
//                   Reserve Now!
//                 </a>
//               </div>
//             </div>
//           </>
//         )}

//         <style jsx>{`
//           @keyframes slideUp {
//             0% {
//               opacity: 0;
//               transform: translateY(50px);
//             }
//             100% {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }
//           .animate-slideUp {
//             animation: slideUp 0.85s forwards;
//           }
//           @keyframes menuSlideRightToLeft {
//             0% {
//               transform: translateX(100%);
//             }
//             100% {
//               transform: translateX(0);
//             }
//           }
//           .animate-menuSlideRightToLeft {
//             animation: menuSlideRightToLeft 0.55s ease forwards;
//           }
//           @keyframes menuSlideLeftToRight {
//             0% {
//               transform: translateX(0);
//             }
//             100% {
//               transform: translateX(100%);
//             }
//           }
//           .animate-menuSlideLeftToRight {
//             animation: menuSlideLeftToRight 0.55s ease forwards;
//           }
//         `}</style>
//       </header>

//       <div className="max-w-[1400px] mx-auto px-6 lg:px-20 lg:mt-8">
//         <div ref={addToRefs} className="grid grid-cols-1 lg:grid-cols-2 gap-10">
//           <div className="hidden lg:block mt-32 space-y-10 xl:px-24 lg:px-5">
//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Dates</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px]">
//                 3 September – 10 September
//               </p>
//             </div>

//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Guests</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 2 Guests
//               </p>
//             </div>
//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Name</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 Alice Willson
//               </p>
//             </div>

//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Email</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 alice@gmail.com
//               </p>
//             </div>

//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Mobile</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 9098765423
//               </p>
//             </div>

//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">
//                 {" "}
//                 CheckIn-CheckOut (Nights)
//               </p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 24/12/25-25/12/25 (1 Night)
//               </p>
//             </div>
//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]">Special Request</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 Chef on call
//               </p>
//             </div>

//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]"> Taxes</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 RS 1000
//               </p>
//             </div>
//             <div className="flex items-center justify-between">
//               <p className="text-[#948A78] text-[20px]"> Price</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-44">
//                 RS 6000
//               </p>
//             </div>

//             <div className="flex items-center justify-between pr-20">
//               <p className="text-[#948A78] text-[20px]">Total Cost</p>
//               <p className="text-[#948A78] tracking-[0.25em] uppercase text-[13px] mr-[20vh] 2xl:mr-[8vh]">
//                 Rs 7000
//               </p>
//             </div>
//           </div>

//           <div className="hidden lg:flex flex-col items-end">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public"
//               alt="Trip Confirmation"
//               className="w-[70vh] h-[50vh] xl:w-[80vh] xl:h-[60vh] 2xl:h-[45vh] object-cover"
//             />

//             <div className="bg-[#f5f2f0] py-10 px-10 mt-14 w-[70vh] xl:w-[80vh] 2xl:w-[70vh]">
//               <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[13px] mb-6 -ml-56">
//                 Trip Confirmed
//               </p>

//               <p className="text-[#948A78] text-[20px] leading-relaxed -ml-10">
//                 Congratulations, your trip with us is
//                 <br />
//                 booked with us!
//               </p>

//               <p className="text-[#948A78] text-[20px] mt-4 -ml-10">
//                 We look forward to hosting you!
//               </p>
//             </div>
//           </div>
//         </div>

//         <div ref={addToRefs} className="lg:hidden mt-10">
//           <div className="w-full flex justify-center mt-10">
//             <div className="bg-[#f5f2f0] py-10 px-8 w-full max-w-[450px]">
//               <p className="uppercase tracking-[0.35em] text-[#BFB5A3] text-[12px] mb-4">
//                 Trip Confirmed
//               </p>

//               <p className="text-[#948A78] text-[18px] leading-relaxed">
//                 Congratulations, your trip with us is booked!
//               </p>

//               <p className="text-[#948A78] text-[18px] mt-4">
//                 We look forward to hosting you!
//               </p>
//             </div>
//           </div>

//           <div className="mt-32 space-y-6 px-10 sm:px-52">
//             <div className="flex justify-between pb-2">
//               <p className="text-[#948A78] text-[18px]">Dates</p>
//               <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase mt-2 ml-14">
//                 3&nbsp;September&nbsp;To
//                 <br />
//                 10&nbsp;September
//               </p>
//             </div>

//             <div className="flex justify-between pb-2">
//               <p className="text-[#948A78] text-[18px]">Guests</p>
//               <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase mt-2 mr-4">
//                 2 Guests
//               </p>
//             </div>

//             <div className="flex justify-between pb-20">
//               <p className="text-[#948A78] text-[18px]">
//                 Total <br /> Cost
//               </p>
//               <p className="text-[#948A78] tracking-[0.2em] text-[12px] uppercase mt-2 mr-10">
//                 Rs xx
//               </p>
//             </div>
//           </div>

//           <div className="-mx-6 lg:hidden">
//             <img
//               src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/feedbd35-5f4e-43a6-9d88-536119619600/public"
//               alt="Trip"
//               className="w-screen h-[40vh] sm:h-[65vh] object-cover"
//             />
//           </div>
//         </div>
//       </div>

//       <NewFooter />
//     </>
//   );
// };

// export default Confirmation;
